/* eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';

// Redux
import { useSelector, useDispatch } from 'react-redux';

// Material
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Radio from '@material-ui/core/Radio';

// Actions
import * as FacialActions from 'store/ducks/facial/actions';

// Types
import { ApplicationState } from 'store';

// Constants
import FACIAL from 'constants/facial';

// Styles
import useStyles from './statusFilter.styles';

const StatusFilter: React.FC = () => {
  const classes = useStyles();

  const dispatch = useDispatch();

  const selectedStatus = useSelector(
    (state: ApplicationState) => state.facial.selectedStatus,
  );

  const handleStatus = (status: number) => {
    const found = selectedStatus.filter((e) => e === status);
    dispatch(
      FacialActions.setSelectedStatus({
        selectedStatus:
          found.length > 0
            ? selectedStatus.filter((e) => e !== status)
            : [...selectedStatus, status],
      }),
    );
  };

  return (
    <List dense>
      {Object.values(FACIAL.STATUS).map((item) => (
        <ListItem key={item.LABEL} button>
          <ListItemText
            id={item.LABEL}
            primary={item.LABEL}
            onClick={() => handleStatus(item.VALUE)}
            classes={{ root: classes.itemText }}
          />
          <ListItemSecondaryAction>
            <Radio
              edge='end'
              name={item.LABEL}
              color='primary'
              onClick={() => handleStatus(item.VALUE)}
              checked={
                selectedStatus.filter((e) => e === item.VALUE).length > 0
              }
              inputProps={{ 'aria-labelledby': item.LABEL }}
            />
          </ListItemSecondaryAction>
        </ListItem>
      ))}
    </List>
  );
};

export { StatusFilter };
export default StatusFilter;
